import { render, staticRenderFns } from "./EvaluationImport.vue?vue&type=template&id=f64729b4&scoped=true&"
import script from "./EvaluationImport.vue?vue&type=script&lang=js&"
export * from "./EvaluationImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64729b4",
  null
  
)

export default component.exports